<template>
	<div id="app">
		<b-sidebar id="sidebar-right" no-header right backdrop>
			<!-- drawer-content -->

			<!-- menu close icon -->
			<div class="float-right my-4 mr-4 bar-container" v-b-toggle.sidebar-right>
				<div class="bar bar1"></div>
				<div class="bar bar2"></div>
				<div class="bar bar3"></div>
			</div>

			<!-- drawer menu -->
			<DrawerMenu v-bind:pages="pages"></DrawerMenu>
		</b-sidebar>

		<!-- main content -->

		<!-- logo and menu -->
		<div class="container text-center">
			<div class="row">
				<!-- logo -->
				<div class="col-7 col-md-6 offset-md-3">
					<a href="/">
						<img src="@/assets/LG fc Simone Busscher V2.png" class="logo mt-2 mb-3" />
					</a>
				</div>

				<!-- menu hamburger icon -->
				<div class="col-5 col-md-2 offset-md-1 mt-4">
					<div class="float-left">MENU</div>
					<div class="float-right bar-container" v-b-toggle.sidebar-right>
						<div class="bar"></div>
						<div class="bar"></div>
						<div class="bar"></div>
					</div>
				</div>
			</div>
		</div>

		<!-- router views -->
		<router-view />
	</div>
</template>

<script>
import Vue from 'vue';
import { SidebarPlugin } from 'bootstrap-vue';
Vue.use(SidebarPlugin);

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

import DrawerMenu from '@/components/DrawerMenu.vue';

const Home = () => import(/* webpackChunkName: "home" */ '@/views/Home.vue');
const Main = () => import(/* webpackChunkName: "main" */ '@/views/Main.vue');
const Prices = () => import(/* webpackChunkName: "prices" */ '@/views/Prices.vue');

export default {
	data() {
		return {};
	},
	components: {
		DrawerMenu,
	},
	computed: {
		pages() {
			let pages = this.$store.getters.pages;
			// console.log('app.vue computed pages', pages.length);
			if (pages.length > 0) {
				this.getRoutes();
				return pages;
			}
		},
	},
	created() {
		// console.clear();
		// console.log('app.vue');
	},
	methods: {
		getRoutes() {
			let response = this.$store.getters.pages;

			let routes = [];
			for (let i = 0; i < response.length; i++) {
				let path = response[i].path;

				let component;
				if (path == '') {
					component = Home;
				} else if (path == 'tarieven') {
					component = Prices;
				} else {
					component = Main;
				}

				const element = {
					path: '/' + path,
					name: path,
					component: component,
					props: { route: path },
				};
				routes.push(element);
			}

			routes.push({
				path: '/cms',
				name: 'cms',
				component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms.vue'),
				props: { route: '/cms' },
			});

			routes.push({
				path: '/shoppingcart',
				name: 'shoppingcart',
				component: () => import(/* webpackChunkName: "shoppingcart" */ '@/webshop/ShoppingCart.vue'),
				props: { route: '/shoppingcart' },
			});

			routes.push({
				path: '/redirect',
				name: 'redirect',
				component: () => import(/* webpackChunkName: "redirect" */ '@/webshop/Redirect.vue'),
				props: { route: '/redirect' },
			});

			routes.push({
				path: '/orders',
				name: 'orders',
				component: () => import(/* webpackChunkName: "orders" */ '@/webshop/Orders.vue'),
				props: { route: '/orders' },
			});

			routes.push({
				path: '/ideal',
				name: 'ideal',
				component: () => import(/* webpackChunkName: "ideal" */ '@/webshop/Ideal.vue'),
				props: { route: '/ideal' },
			});

			// routes.push({
			// 	path: '/login',
			// 	name: 'login',
			// 	component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
			// 	props: { route: '/login' }
			// });

			this.$router.addRoutes(routes);

			// uncomment this for generating info for sitemap.txt file
			// console.log('found routes', routes);
			// let url = 'http://simonebusscher.nl';
			// routes.forEach(element => {
			//     console.log(url + element.path);
			// });
		},
	},
	watch: {
		$route: function (to, from) {
			// console.log(from.name, '=>', to);
			// if (to.name == 'cms') {
			// 	if (this.$cookies.get('user_session') != '25j_7Sl6xDq2Kc3ym0fmrSSk2xV2XkUkX') {
			// 		console.log('cookie not okay');
			// 		this.$router.push('/login');
			// 	}
			// }
			let id = this.$store.getters.getPageId(to.name);
			this.$store.dispatch('getQuarks', id);
		},
	},
};
</script>

<style>
@import '~bootstrap/dist/css/bootstrap.min.css';
@import '~bootstrap-vue/dist/bootstrap-vue.min.css';
@import url('https://use.typekit.net/ugr3myj.css');

h1 {
	/* font-size: 26pt; */
	font-size: 20pt;
	font-weight: 500;
	font-style: normal;
	text-transform: uppercase;
}

h2 {
	font-size: 26pt;
	font-weight: 400;
	font-style: normal;
	text-transform: uppercase;
}

h3 {
	font-size: 20px;
	font-weight: 400;
	font-style: normal;
	text-transform: uppercase;
}

.quote {
	/* font-size: 21px; */
	font-weight: 400;
	font-style: italic;
}

#app {
	font-family: ff-tisa-sans-web-pro, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: left;
	color: #2c3e50;
}

a:hover {
	text-decoration: none;
}

/* foreground colors */
.fg-royal {
	color: #fdd493;
}
.fg-apricot {
	color: #f39200;
}
.fg-pink {
	color: #e39ba3;
}
.fg-light-pink {
	color: #f0d6d7;
}
.fg-red {
	color: #be1622;
}

/* background colors */
.bg-white {
	background-color: white;
}
.bg-royal {
	background-color: #fdd493;
}
.bg-apricot {
	background-color: #f39200;
}
.bg-pink {
	background-color: #e39ba3;
}
.bg-light-pink {
	background-color: #f0d6d7;
}
.bg-red {
	background-color: #be1622;
}
.bg-black {
	background-color: black;
}

/* button hovered state */
.hovered:hover {
	cursor: pointer;
	opacity: 0.8;
}

/* aspect ratio */

.aspect-ratio-box {
	margin: 0;
	height: 0;
	overflow: hidden;
	padding-top: 33%;
	background: yellowgreen;
	position: relative;
}
.aspect-ratio-box-inside {
	margin: 0;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

/* control aspect ratio via custom property */
/* <div style="--aspect-ratio:3;" class="bg-royal">
    <div class="aspect-ratio-box-inside">Happy Birthday</div>
</div> */

[style*='--aspect-ratio'] > :first-child {
	width: 100%;
}
[style*='--aspect-ratio'] > img {
	height: auto;
}
@supports (--custom: property) {
	[style*='--aspect-ratio'] {
		position: relative;
	}
	[style*='--aspect-ratio']::before {
		content: '';
		display: block;
		padding-bottom: calc(100% / (var(--aspect-ratio)));
	}
	[style*='--aspect-ratio'] > :first-child {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
	}
}

.logo {
	max-width: 200px;
}

/* hamburger icon */
.bar {
	width: 35px;
	height: 5px;
	background-color: black;
	margin: 6px 0;
}

.bar-container {
	display: inline-block;
	cursor: pointer;
}

.bar1 {
	-webkit-transform: rotate(-45deg) translate(-8px, 8px);
	transform: rotate(-45deg) translate(-8px, 7px);
}
.bar2 {
	opacity: 0;
}
.bar3 {
	-webkit-transform: rotate(45deg) translate(-8px, -8px);
	transform: rotate(45deg) translate(-8px, -8px);
}
</style>
